import React, { PropsWithChildren } from 'react';
import { Grid, Typography } from '@mui/material';
import { colors } from 'theme/colors';
import styled from '@emotion/styled';
import { StyledAuthContent } from './styles';

const AuthTemplate = ({ children }: PropsWithChildren<{}>) => (
  <Grid container justifyContent="center">
    <StyledAuthContent item container>
      {children}
    </StyledAuthContent>
  </Grid>
);

export const StyledAuthHeader = styled(Typography)`
  color: ${colors.primary500};
  font-weight: 600;
  font-size: 2rem;
  text-align: center;
`;

export { AuthTemplate };
